'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dropdown = require('dropdown');

var _reactIframe = require('react-iframe');

var _reactIframe2 = _interopRequireDefault(_reactIframe);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(
  'p',
  null,
  'Code:'
);

var _ref2 = _react2.default.createElement(
  'p',
  null,
  'Preview:'
);

var _ref3 = _react2.default.createElement(
  'p',
  null,
  'No preview to display (no profile selected)'
);

var ReviewBadgeExample = function ReviewBadgeExample(props) {
  var isProfileTypeSelected = props.selectedProfileType && (props.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE);
  var profileItems = props.selectedProfileType && props.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE && props.fetchedSpecialists || props.selectedProfileType && props.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && props.fetchedPractices || [];

  var searchQuery = '/' + props.uri + (0, _constants.queryStringFromObject)({
    profileType: props.selectedProfileType && props.selectedProfileType.id || '',
    profileId: props.selectedProfile && props.selectedProfile.uriId || '',
    profilesIds: props.selectedMultipleProfiles && props.selectedMultipleProfiles.map(function (item) {
      return item.uriId;
    }) || [],
    link: props.hrefLink
  });

  return _react2.default.createElement(
    'div',
    { className: _style2.default.exampleSection },
    _react2.default.createElement(
      'h2',
      null,
      props.title
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: _style2.default.selectDescription },
        'Profile Type:'
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.dropdownContainer },
        _react2.default.createElement(_dropdown.Dropdown, {
          className: _style2.default.profileDropdown,
          items: _constants.PROFILE_TYPES,
          readonly: true,
          selectedItem: props.selectedProfileType,
          onItemSelected: props.onProfileTypeSelected,
          placeholder: 'Select a profile type',
          ItemRenderer: function ItemRenderer(rendererProps) {
            var item = rendererProps.item,
                nameTransform = rendererProps.nameTransform;

            return _react2.default.createElement(
              'div',
              { className: '' + _style2.default.dropdownItem },
              item.iconUri ? _react2.default.createElement('img', { src: item.iconUri, alt: 'icon' }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
              _react2.default.createElement(
                'span',
                null,
                nameTransform(item)
              )
            );
          } })
      ),
      isProfileTypeSelected && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: _style2.default.selectDescription },
          'Profile:'
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.dropdownContainer },
          _react2.default.createElement(_dropdown.Dropdown, {
            className: _style2.default.profileDropdown,
            items: profileItems,
            readonly: !(props.selectedProfileType && (props.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE)),
            selectedItem: props.selectedProfile,
            onItemSelected: props.onProfileSelected,
            onTextChanged: function onTextChanged(filter) {
              return props.getDirectoryAutocomplete(filter, props.selectedProfileType && props.selectedProfileType.id);
            },
            placeholder: 'Type a name',
            ItemRenderer: function ItemRenderer(rendererProps) {
              var item = rendererProps.item,
                  nameTransform = rendererProps.nameTransform;

              return _react2.default.createElement(
                'div',
                { className: '' + _style2.default.dropdownItem },
                item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                _react2.default.createElement(
                  'span',
                  null,
                  nameTransform(item)
                )
              );
            }
          })
        )
      ),
      isProfileTypeSelected && props.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: _style2.default.selectDescription },
          'Additional profiles:'
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.dropdownContainer },
          _react2.default.createElement(_dropdown.Dropdown, {
            className: _style2.default.profileDropdown,
            items: profileItems,
            readonly: !(props.selectedProfileType && (props.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE)),
            selectedItem: props.onMultipleProfileSelected,
            onItemSelected: props.onMultipleProfileSelected,
            onTextChanged: function onTextChanged(filter) {
              return props.getDirectoryAutocomplete(filter, props.selectedProfileType && props.selectedProfileType.id);
            },
            placeholder: 'Type a name',
            clearOnSelect: true,
            ItemRenderer: function ItemRenderer(rendererProps) {
              var item = rendererProps.item,
                  nameTransform = rendererProps.nameTransform;

              return _react2.default.createElement(
                'div',
                { className: '' + _style2.default.dropdownItem },
                item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                _react2.default.createElement(
                  'span',
                  null,
                  nameTransform(item)
                )
              );
            }
          })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: _style2.default.selectDescription },
            'Profiles:'
          ),
          props.selectedMultipleProfiles.map(function (profile) {
            return _react2.default.createElement(
              'div',
              null,
              profile.name,
              _react2.default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    props.onMultipleProfileRemoved(profile.id);
                  },
                  className: _style2.default.removeProfileButton
                },
                'Remove'
              )
            );
          })
        )
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: _style2.default.selectDescription },
        'Full link to page:'
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.dropdownContainer },
        _react2.default.createElement('input', {
          className: _style2.default.dropdownItem,
          value: props.hrefLink,
          placeholder: 'https://example.com/contacts',
          onChange: function onChange(event) {
            return props.onHrefLinkChanged(event.target.value);
          },
          style: { width: '250px' }
        })
      )
    ),
    props.selectedProfileType && props.selectedProfile && _react2.default.createElement(
      'div',
      { className: _style2.default.codeSnippet },
      _ref,
      _react2.default.createElement(
        'pre',
        null,
        _react2.default.createElement(
          'code',
          null,
          '<iframe frameborder="0" src="',
          'https://widgets.doctify.co.uk' + searchQuery,
          '" style="position:relative;display:block;height:122px;width:105px;border:none;border-radius:4px;overflow:hidden;"></iframe>'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _style2.default.practiceReviewsIframe },
      _ref2,
      props.selectedProfileType && props.selectedProfile && _react2.default.createElement(_reactIframe2.default, {
        url: '' + props.baseUrl + searchQuery,
        width: '105px',
        height: '122px',
        display: 'block',
        position: 'relative',
        styles: { 'border-radius': '4px', 'overflow': 'hidden' }
      }) || _react2.default.createElement(
        'div',
        { className: [_style2.default.noPreview, _style2.default.reviewsBadgeExample].join(' ') },
        _ref3
      )
    )
  );
};

ReviewBadgeExample.propTypes = {
  title: _propTypes2.default.string.isRequired,
  baseUrl: _propTypes2.default.string.isRequired,
  uri: _propTypes2.default.string.isRequired,
  hrefLink: _propTypes2.default.string.isRequired,
  selectedProfileType: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  selectedProfile: _propTypes2.default.shape({
    uriId: _propTypes2.default.string
  }).isRequired,
  selectedMultipleProfiles: _propTypes2.default.array.isRequired,
  fetchedSpecialists: _propTypes2.default.array.isRequired,
  fetchedPractices: _propTypes2.default.array.isRequired,
  onProfileTypeSelected: _propTypes2.default.func.isRequired,
  onProfileSelected: _propTypes2.default.func.isRequired,
  onMultipleProfileSelected: _propTypes2.default.func.isRequired,
  onMultipleProfileRemoved: _propTypes2.default.func.isRequired,
  getDirectoryAutocomplete: _propTypes2.default.func.isRequired,
  onHrefLinkChanged: _propTypes2.default.func.isRequired
};

ReviewBadgeExample.defaultProps = {
  title: '',
  baseUrl: '',
  uri: '',
  hrefLink: '',
  selectedProfileType: null,
  selectedProfile: null,
  selectedMultipleProfiles: [],
  fetchedSpecialists: [],
  fetchedPractices: [],
  onProfileTypeSelected: function onProfileTypeSelected() {},
  onProfileSelected: function onProfileSelected() {},
  onMultipleProfileSelected: function onMultipleProfileSelected() {},
  onMultipleProfileRemoved: function onMultipleProfileRemoved() {},
  getDirectoryAutocomplete: function getDirectoryAutocomplete() {},
  onHrefLinkChanged: function onHrefLinkChanged() {}
};

exports.default = ReviewBadgeExample;